import { useEffect, useState } from 'react'
import { useMediaQuery } from 'react-responsive';

const BackGroImg = () => {

  const isMobile = useMediaQuery({ query: '(max-width: 500px)' });
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated) {
            setHasAnimated(true);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );

    const target = document.querySelector('.design2Textdiv');
    if (target) observer.observe(target);

    return () => {
      if (target) observer.unobserve(target);
    };
  }, [hasAnimated]);

  useEffect(() => {
    if (!isMobile) return;

    const handleScroll = () => {
      const parallaxElement = document.querySelector('.design2');
      if (parallaxElement) {
        const scrollY = window.scrollY;
        parallaxElement.style.backgroundPositionY = `${scrollY * 0.5}px`;
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isMobile]);

  return (
    <>
      <div className='marginb'>
        <div className='design2'>
          <img className='design2img' src="/images/design1.png" alt="Design" />

          <div className={`design2Textdiv ${hasAnimated ? 'animateText' : ''}`}>
            <div className='design2wlcmh1div'>
              <p className='design2wlcmh1sec'>1970</p>
              <h1 className='design2wlcmh1'>Roop Sweets</h1>
            </div>
            <h3 className='quote1'>Dil ki baat zubaan pe aai jab khayi <br /> Roop ki mithai</h3>
          </div>
        </div>
      </div>
    </>
  )
}

export default BackGroImg
